const ANDROID_USER_AGENT_PATTERN = /android/i;
const IOS_USER_AGENT_PATTERN = /iphone|ipad|ipod/i;

/**
 * Redirect authentication depends on temporary browser storage surviving a
 * full round-trip through the identity provider. Chrome on Android can lose
 * that state (notably after a logout), leaving the user on Firebase's
 * /__/auth/handler error page. A popup keeps the application context alive;
 * on Android its helper is deliberately hosted outside the installed PWA's
 * navigation scope (see firebaseAuthDomain.js).
 *
 * iOS keeps the redirect flow for now because standalone Safari/PWA popup
 * handling needs its own device validation. Every other supported browser is
 * popup-first.
 */
export function resolveProviderAuthMode({
  forcePopup = false,
  isInAppBrowser = false,
  userAgent = "",
} = {}) {
  if (forcePopup || isInAppBrowser) {
    return "popup";
  }

  const normalizedUserAgent = String(userAgent || "");

  if (ANDROID_USER_AGENT_PATTERN.test(normalizedUserAgent)) {
    return "popup";
  }

  if (IOS_USER_AGENT_PATTERN.test(normalizedUserAgent)) {
    return "redirect";
  }

  return "popup";
}
